import usePaginatedQuery, { PaginatedResult, PaginationParams } from "./usePaginatedQuery";
import { QueryOptions } from "../components/Common/useQuery";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";
import OrderTransactionDto from "../components/Common/dtos/OrderTransactionDto";

export interface OrderTransactionPaginationParams extends PaginationParams {
  filterText?: string;
  itemId?: string;
  siteId?: string;
  startDate?: string;
  endDate?: string;
  partnerSiteId?: string;
}

const useGetOrderTransactions = (
  params: OrderTransactionPaginationParams,
  options?: QueryOptions<PaginatedResult<OrderTransactionDto>>
) => {
  const business = useSelectedBusiness();
  const baseUrl = `/api/businesses/${business.id}/orderTransactions`;

  return usePaginatedQuery<OrderTransactionDto>(baseUrl, params, options);
};

export default useGetOrderTransactions;